import React, { ChangeEvent } from 'react';
import * as app from "../services/AppService";
import { RowItem } from '../models/Core/row-item';
import { InterfaceComponentsProps } from '../models/Core/componentsCore';

interface Props extends RowItem, InterfaceComponentsProps {
    type?: string;
    model: number;
    placeholder?: string;
    elmKey?: string;
    minValue?: number;
    maxValue?: number;
    tableClass?: string;
    containerClass?: string;
    onChange?: (value: number) => void;
    onBlur?: (...args: any) => void;
}

export default function Number(props : Props) {

  function handler(event : ChangeEvent<HTMLInputElement>) {
    const { value } = event.target;
    if (props.onChange && typeof props.onChange == "function") props.onChange(+value);
  }
  let input = (
    <input
      type="number"
      id={props.id ? props.id : "num" + props.label}
      key={props.elmKey}
      className={`form-control form-control-sm border rounded ${
        props.isTable ? " border-1  text-center " + props.tableClass : props.class
      }`}
      disabled={props.disabled}
      onChange={handler}
      value={props.model}
      onBlur={props.onBlur}
      placeholder={app.translate(props.placeholder)}
      min={props.minValue}
      max={props.maxValue}
    />
  );
  return props.isTable ? (
    input
  ) : (
    <div className="mt-1">
      <label className={`${props.labelClass}`}>{app.translate(props.label)}</label>
      <div className={`input-group rounded  ${props.containerClass}`}>
        {input}
        {props.icon && (
          <button className="btn btn-light" type="button" disabled>
            <i className={"text-primary-emphasis " + `icofont-${props.icon}`} />
          </button>
        )}
      </div>
    </div>
  );
}

Number.defaultProps = {
    class: " ",
    placeholder: "",
    labelClass: " fw-semibold text-primary-emphasis ",
    containerClass: " ",
    disabled: false,
    elmKey: "num",
    isTable: false,
    minValue: 0
}


